<template>
  <div>
      <b-card
        no-body
        border-variant="msstream"
        class="marginal"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 class="m-0">
            <b-row class="align-items-center justify-content-center">
            <b-icon icon="key"></b-icon>&nbsp;
              {{$ml.get('apikeystitle')}}
            &nbsp;<b-badge>{{apikeys.length}}</b-badge>
            </b-row>
          </h5>
        </b-card-header>
        <b-card-body>
            <div class="apikey-grid apikey-grid-size">
                <b-table
                  show-empty
                  centered
                  responsive
                  striped
                  bordered
                  :items="apikeys"
                  :fields="apiTable"
                >
                  <template v-slot:cell(delete)="row">
                      <b-button variant="redsmall" @click="currentApiKey = row.item; showModal('confirmDeleteApiKey');">
                          <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                      </b-button>
                  </template>
                </b-table>
            </div>
            <b-row class="align-items-center justify-content-around marginaltop">
                <b-col cols="auto">
                  <b-button @click="showModal('newApiKey')" variant="msstreamblue"><b-icon icon="key"></b-icon>&nbsp;{{$ml.get('createapikey')}}</b-button>
                <!-- TODO : faire les inputs ApiKeys -->
                <!-- TODO : faire les textes et traductions -->
                </b-col>
            </b-row>
        </b-card-body>
      </b-card>


  <b-modal ref="newApiKey" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('createapikey')}}
        </h4>
      </div>
      <b-form @submit.prevent="">
        <p style="line-height:normal; text-align:center" v-html="$ml.get('apikeyuploadsuccess')"></p>
        <b-form-group label="">
          <b-form-checkbox-group
            id="checkbox-group-2"
            v-model="newKey.functions"
            name="flavour-2"
          >
            <b-form-checkbox value="/api/feedback/energy/fromkey" size="sm">Energy</b-form-checkbox>
            <b-form-checkbox value="/api/videos/livestatus/fromkey" size="sm">Live Status</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <b-form-group
          id="descriptionapikey"
          label="Description :"
          label-for="description_apikey"
        >
          <b-form-input
            id="description_apikey"
            v-model="newKey.description"
            type="text"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="paramsjson"
          label="Fixed parameters :"
          label-for="params_json"
        >
          <b-form-input
            id="params_json"
            v-model="newParams"
            type="textarea"
          ></b-form-input>
        </b-form-group>

        

        <b-row class="justify-content-around">
          <b-btn class="col-md-3 col-5" variant="msstreamblue" @click="postApiKey();hideModal('newApiKey');">
            <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
            Ok
          </b-btn>
          <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('newApiKey');">
            <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
            {{$ml.get('close')}}
          </b-btn>
        </b-row>
      </b-form>
    </b-modal>


    <b-modal ref="successNewApiKey" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('apikey')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('apikeyuploadsuccess')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('successNewApiKey');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorNewApiKey" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('apikey')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('apikeyuploaderror')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorNewApiKey');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmDeleteApiKey" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('apikey')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('apikeydeleteconfirm')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="msstreamblue" @click="hideModal('confirmDeleteApiKey');deleteApiKey(currentApiKey)">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('confirmDeleteApiKey');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorDeleteApiKey" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('apikey')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('apikeydeleteerror')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorDeleteApiKey');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

     <b-modal ref="InvalidJson" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          Invalid JSON for parameters
        </h4>
      </div>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('InvalidJson');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { BASE_URL } from "@/services/base-url";
import ApiKeyService from "@/services/apikeys.service";
let apikeyService = new ApiKeyService();
export default {
  name: "ApiKeyPage",
  components: {

  },
  data: function () {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      apikeys: [],
      currentApiKey: null,
      newParams: "{}",
      newKey: {},
      isCreating: false,
      apiTable:  [
        { key: "key", label: "API Key", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "description", label: "Description", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "functions", label: "Functions", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "params", label: "Parameters", sortable: true, thClass: 'text-center', tdClass: 'align-middle' },
        { key: "delete", label: "Remove", sortable: true, thClass: 'text-center', tdClass: 'align-middle' }
      ],
    };
  },
  mounted() {
    this.resetNewKey();
    this.getApiKeys();
  },
  computed: {
   
  },
  methods: {
    resetNewKey() {
      this.newParams = "{}";
        this.newKey = {
            "functions": ["/api/feedback/energy/fromkey"],
            "params": "",
            "client": this.clientView,
            "description": ""
        }
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    getApiKeys() {
        apikeyService.getApiKeys({filter: JSON.stringify({client: this.clientView})}, this.$auth.token())
        .then((apikeys) => {
            this.apikeys = apikeys._embedded;
        }).catch(err => {

        })

    },
    postApiKey() {
        try {
          this.newKey.params = JSON.parse(this.newParams)
        } catch(err) {
          this.showModal('InvalidJson')
        }
        apikeyService.postApiKey(this.newKey, this.$auth.token())
        .then((apikey) => {
            this.getApiKeys();
            this.resetNewKey();
            this.showModal('successNewApiKey');
        }).catch(err => {
            this.showModal('errorNewApiKey');
        })
    },
    deleteApiKey() {
        let index = this.apikeys.findIndex(x => x === this.currentApiKey);
        if (index > -1) {
            apikeyService.deleteApiKey(this.currentApiKey.uuid, this.$auth.token())
            .then(() => {
                this.apikeys.splice(index, 1);
            }).catch(err => {
                this.showModal('errorDeleteApiKey');
            })
        } else {
          this.getApiKeys();
        }
    }

  },
};
</script>
<style scoped lang="scss">
.apikey-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    justify-items: center
}
</style>